import React from 'react';
import { Button } from 'design-system';
import { FormattedMessage } from 'react-intl';
import styles from './SelectDocument.module.css';

const SelectDocument = ({ handelSelectedDocument, selectedDocument }) => {
  const certificateTypeMapper = {
    death_certificate: <FormattedMessage id="death_certificate" />,
    birth_certificate: <FormattedMessage id="birth_certificate" />,
    invoice: <FormattedMessage id="invoice" />,
    power_of_attorney: <FormattedMessage id="power_of_attorney" />,
    driving_license: <FormattedMessage id="driving_license" />,
  };

  return (
    <div className={styles['container']}>
      {/* <div className={styles['heading']}>
        <FormattedMessage id='upload_document' />
      </div>
      <div className={styles['sub-heading']}>
        <FormattedMessage id='upload_document_description' />
      </div> */}
      <div className={styles['document-container']}>
        {Object.keys(certificateTypeMapper).map((key, index) => {
          const isSelected = selectedDocument === key;
          return (
            <Button
              key={index}
              block
              shape="round"
              size="small"
              type={isSelected ? 'primary' : 'default'}
              className={styles.documentButton}
              onClick={() => handelSelectedDocument(isSelected ? null : key)}
            >
              {certificateTypeMapper[key]}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default SelectDocument;
